import { fetcher } from '@commenda/utils';
import { useQuery } from '@tanstack/react-query';
import { mailroomKeys } from './keys';
import { MailroomResponse } from './types';

const getMailrooms = async (options?: MailroomQueryOptions) => {
  const queryParams = new URLSearchParams();
  if (options?.corporationId) {
    queryParams.append('corporationId', options.corporationId.toString());
  }
  if (options?.ids) {
    queryParams.append('ids', options.ids.join(','));
  }

  const queryString = queryParams.toString();
  const url = `mailroom${queryString ? `?${queryString}` : ''}`;

  const response = await fetcher(url, {
    method: 'GET',
  });

  if (!response.ok) throw new Error('Failed to fetch mailrooms');

  return (await response.json()) as MailroomResponse;
};

type MailroomQueryOptions = {
  corporationId: number;
  ids?: string[];
};

const useMailrooms = (options: MailroomQueryOptions) => {
  return useQuery({
    queryKey: [
      mailroomKeys.FETCH_MAILROOMS,
      options?.corporationId,
      options?.ids,
    ],
    queryFn: () => getMailrooms(options),
    enabled: !!options.corporationId,
  });
};

export { useMailrooms };
